import { Close } from '@mui/icons-material';
import {
  CloseButtonProps,
  ToastContainer as ToastifyToastContainer,
} from 'react-toastify';
import { IconButton } from '@legacy/components/mui-components/IconButton';

const ToastCloseButton = ({ closeToast, type }: Partial<CloseButtonProps>) => (
  <IconButton
    color={type === 'info' ? undefined : type}
    data-automation-id="ToastCloseButton"
    onClick={closeToast}
    sx={{
      position: 'absolute',
      right: 8,
      top: 10,
      border: 'none',
    }}
    title="Close"
    size="small"
  >
    <Close fontSize="small" />
  </IconButton>
);

export const ToastContainer = () => (
  <ToastifyToastContainer
    position="bottom-center"
    autoClose={false}
    hideProgressBar
    newestOnTop
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    closeButton={<ToastCloseButton />}
    icon={false}
    style={{ zIndex: 9999 }}
    toastStyle={{ padding: 0 }}
  />
);
